import React, { ReactNode } from 'react';

import { IBasicStyledProps } from '@notino/react-styleguide-v20';

import { ReactFCV } from '@types';
import { noop } from '@utils/general';

import { HEADER_TEXT_BASE_FONT_SIZE } from './constants';
import { ETextAlignment } from './model';
import {
  StyledWarningModal,
  StyledActionButton,
  StyledWarningModalContent,
  StyleMessageLine,
  StyledHeaderLine,
} from './styles';

export interface IGeneralModalBody extends IBasicStyledProps {
  headerBold?: boolean;
  headerText?: ReactNode;
  headerFontSize?: number;
  messagesBold?: boolean;
  messagesText: ReactNode[];
  textAlignment?: ETextAlignment;
  buttonText?: string;
  onButtonClick?: () => void;
  icon?: ReactNode;
}

export const GeneralModalBody: ReactFCV<IGeneralModalBody> = ({
  messagesText,
  onButtonClick = noop,
  buttonText,
  headerText = '',
  headerBold = false,
  headerFontSize = HEADER_TEXT_BASE_FONT_SIZE,
  messagesBold = true,
  textAlignment = ETextAlignment.CENTER,
  icon,
  ...rest
}) => (
  <StyledWarningModal {...rest}>
    <StyledWarningModalContent textAlign={textAlignment}>
      {Boolean(icon) && icon}
      {headerText && (
        <StyledHeaderLine fontSize={headerFontSize} bold={headerBold}>
          {headerText}
        </StyledHeaderLine>
      )}
      {messagesText.map((text: ReactNode) => (
        // eslint-disable-next-line
        <StyleMessageLine data-testid="message-line" bold={messagesBold} key={`${String(text)}-message`}>
          {text}
        </StyleMessageLine>
      ))}
    </StyledWarningModalContent>
    {buttonText && (
      <StyledActionButton data-testid="action-btn" onClick={onButtonClick}>
        {buttonText}
      </StyledActionButton>
    )}
  </StyledWarningModal>
);
